import { useCallback, useState } from 'react';
import { API, graphqlOperation } from 'aws-amplify';
import {
  GetPlanOutput,
  GetPlanQuery,
  PaddleUpdateUserPlanInput,
  PaddleUpdateUserPlanMutation,
} from '../graphql/api';
import { useDispatch, useSelector } from 'react-redux';
import { IState, IUser } from '../graphql/types';
import { updateUser } from '../actions';
import { getPlan } from '../graphql/queries';
import { paddleUpdateUserPlan } from '../graphql/mutations';
import useMutation from './useMutation';

const usePlan = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const updatePlanMutation = useMutation<
    PaddleUpdateUserPlanInput,
    PaddleUpdateUserPlanMutation
  >(paddleUpdateUserPlan);

  const data = useSelector<IState, IUser | undefined>(state => state.user);

  const updatePlan = useCallback(
    async (planIDToSwitchTo: number) => {
      try {
        const result = await updatePlanMutation.callMutation({
          planIDToSwitchTo,
        });
        if (result.data) {
          // console.log('result from updatePlan: ', result.data);
        }
      } catch (err) {
        console.log('error updating plan: ', err);
      }
    },
    [updatePlanMutation]
  );

  const refetch = useCallback(() => {
    setLoading(true);
    (
      API.graphql(graphqlOperation(getPlan)) as Promise<{
        data: GetPlanQuery;
      }>
    )
      .then(result => {
        if (result.data.getPlan !== null) {
          dispatch(
            updateUser({
              plan: result.data.getPlan as GetPlanOutput,
              planId: (result.data.getPlan as GetPlanOutput).id || '',
            })
          );
        }

        setLoading(false);
      })
      .catch(err => console.log('usePlan error: ', err));
  }, [dispatch]);

  // React.useEffect(() => {
  //   if (userFetching) {
  //     return; // don't reload getPlan when user is still being loaded
  //   }
  //   if (!data || data.planId === '') refetch();
  // }, [data, refetch, userFetching]);

  return { data, refetch, loading, updatePlan };
};

export default usePlan;
